const KEY = 'necs-support-return';
export const safeSupportReturn = value => typeof value === 'string' && (value === '/delete-account' || /^\/(?:support-handoff|mobile-auth)\/[A-Za-z0-9_-]{32,80}$/.test(value)) ? value : null;
export const rememberSupportReturn = value => {
  const path = safeSupportReturn(value);
  if (path) sessionStorage.setItem(KEY, JSON.stringify({ path, expires: Date.now() + 3600000 }));
  return path;
};
export const consumeSupportReturn = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return value?.expires > Date.now() ? safeSupportReturn(value.path) : null;
  } catch { sessionStorage.removeItem(KEY); return null; }
};